// Authoritative store for what's still needed before the Place Order button
// can be enabled. Replaces the older pattern of writing data-configured back
// into the DOM and re-reading it inside the event listener — both
// indirections are gone; modules call set() directly and subscribers re-run
// their check.
//
// Keys are either:
//   • a .checkout__action element — one per required delivery gate
//     (calendar, occasion, single-address, recipients allocation), or
//   • a plain string — currently 'billing' and 'card'.
//
// The recipients action's two visible-vs-hidden DOM nodes (button + Edit
// link) both resolve to the same .checkout__action ancestor, so they map to
// the same state entry — no DOM-node mirroring needed.
//
// To add a status indicator later, expand each entry to carry a label
// alongside `complete` and populate it at register() time — callers don't
// change.

const checks = new Map();
const subs   = new Set();

function notify() { subs.forEach(fn => fn()); }

export function register(key) {
  if (!checks.has(key)) checks.set(key, { complete: false });
}

export function set(key, complete) {
  const entry = checks.get(key);
  if (!entry || entry.complete === !!complete) return;
  entry.complete = !!complete;
  notify();
}

export function subscribe(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}

export function isComplete() {
  for (const { complete } of checks.values()) if (!complete) return false;
  return true;
}
